import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "hero-content" }
const _hoisted_3 = { class: "hero-buttons" }
const _hoisted_4 = {
  class: "cta",
  id: "donate"
}
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "cta-buttons" }


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

// Home view - no reactive logic needed for static content

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Empowering Students Through Technology", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", null, "Providing computers and STEM resources to students across Brevard County", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/request",
            class: "btn btn-primary"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Request a Laptop", -1)
            ]))]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createElementVNode("a", {
            href: "https://portal.spacecoaststem.org/login?signup=true",
            class: "btn btn-secondary"
          }, "Teacher Signup", -1)),
          _createVNode(_component_router_link, {
            to: "/get-involved",
            class: "btn btn-secondary"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Get Involved", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _cache[9] || (_cache[9] = _createStaticVNode("<section class=\"mission\" data-v-7ebd48f5><div class=\"container\" data-v-7ebd48f5><h2 data-v-7ebd48f5>Our Mission</h2><p class=\"mission-text\" data-v-7ebd48f5> At Space Coast STEM, we believe every student deserves access to the technology they need to succeed in today&#39;s digital world. We provide refurbished laptops to students throughout Brevard County who lack access to computers at home. </p></div></section><section class=\"impact\" data-v-7ebd48f5><div class=\"container\" data-v-7ebd48f5><h2 data-v-7ebd48f5>How We Help Students</h2><div class=\"impact-grid\" data-v-7ebd48f5><div class=\"impact-card\" data-v-7ebd48f5><div class=\"impact-icon\" data-v-7ebd48f5>💻</div><h3 data-v-7ebd48f5>Free Laptops</h3><p data-v-7ebd48f5>Providing refurbished laptops to students who need them most</p></div><div class=\"impact-card\" data-v-7ebd48f5><div class=\"impact-icon\" data-v-7ebd48f5>♻️</div><h3 data-v-7ebd48f5>Environmental Impact</h3><p data-v-7ebd48f5>Reducing e-waste by giving used computers a second life instead of landfills</p></div><div class=\"impact-card\" data-v-7ebd48f5><div class=\"impact-icon\" data-v-7ebd48f5>🔧</div><h3 data-v-7ebd48f5>Quality Refurbishment</h3><p data-v-7ebd48f5>Each laptop is thoroughly tested, wiped clean, and loaded with educational software</p></div><div class=\"impact-card\" data-v-7ebd48f5><div class=\"impact-icon\" data-v-7ebd48f5>🐧</div><h3 data-v-7ebd48f5>Linux Education</h3><p data-v-7ebd48f5> Students learn valuable tech skills by using <a href=\"https://linuxmint.com/\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-7ebd48f5>Linux Mint</a>, a Linux distribution based on the industry standard Ubuntu. </p></div></div></div></section>", 2)),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[7] || (_cache[7] = _createElementVNode("h2", null, "Help Us Make a Difference", -1)),
        _cache[8] || (_cache[8] = _createElementVNode("p", null, "Support our mission by donating money or equipment to help more students", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/donate",
            class: "btn btn-primary"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Learn About Donating", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "btn btn-secondary"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Contact Us", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})